import IFrame from "components/IFrame";
import React, { useCallback, useEffect, useState } from "react";
import * as Styled from "./styles";
import SideButtonsGroup from "components/SideButtonsGroup";
import { Slide, SlideProps, Snackbar } from "@mui/material";

interface MessageTemplate {
  type: string;
  payload: Record<string, any>;
}

const IFrameWidget = () => {
  const searchParams = new URLSearchParams(document.location.search);
  const actionButtonPlacement = searchParams.get("actionButtonPlacement");

  const buttonDirection = actionButtonPlacement === 'bottom' ? 'row' : 'column'
  const frameDirection = actionButtonPlacement === 'bottom' ? 'column' : 'row'

  const [token, setToken] = useState<string>();
  const [betDescription, setBetDescription] = useState("");
  const [nonce, setNonce] = useState(0);
  const [scaleTransforming, setScaleTransforming] = useState<number>(1);

  const updateToken = useCallback(async (nonce: number) => {
    const backendUrl = `https://us-central1-bright-practice-331514.cloudfunctions.net/requestGenerateAuthInfo?nonce=${nonce}`;
    const { token } = await fetch(backendUrl).then((response) =>
      response.json()
    );
    setToken(token);
  }, []);

  useEffect(() => {
    updateToken(nonce);
  }, [updateToken, nonce]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (Array.isArray(event.data)) {
        const windowSizeMessage = event.data.find(
          (message: MessageTemplate) => message.type === "WINDOW_SIZE"
        );
        if (windowSizeMessage) {
          const { height, width } = windowSizeMessage.payload;
          if (height < 890) {
            setScaleTransforming(Math.round((height / 890) * 10) / 10);
          }
          window.removeEventListener("message", handleMessage);
        }
      }
    };
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const handleResetClick = () => {
    setNonce(Date.now());
  };

  const generateRandomBet = async (): Promise<string> => {
    const backendUrl = `https://us-central1-bright-practice-331514.cloudfunctions.net/requestGenerateRandomBet?nonce=${nonce}`;
    const { description, outcome } = await fetch(backendUrl).then((response) =>
      response.json()
    );
    return `${outcome.toUpperCase()} - ${description}`;
  };

  const handleSimulationClick = async (): Promise<void> => {
    const description = await generateRandomBet();
    setBetDescription(description);
  };

  const handleCloseClick = () => {
    window.parent.postMessage(
      [
        {
          type: "CLOSE_FRAME",
          payload: true,
        },
      ],
      "*"
    );
  };

  const TransitionComponent = (props: SlideProps) => (
    <Slide {...props} direction="up" />
  );

  return (
    <Styled.PageContainer direction={frameDirection} scaleTransforming={scaleTransforming}>
      {token && (
        <>
          <IFrame src={`https://coinflip.apps.scrimmage.co/?token=${token}`} />
          <SideButtonsGroup
            direction={buttonDirection}
            onResetClick={handleResetClick}
            onSimulationClick={handleSimulationClick}
            onCloseClick={handleCloseClick}
          />
          <Snackbar
            open={Boolean(betDescription)}
            autoHideDuration={3000}
            onClose={() => setBetDescription("")}
            message={betDescription}
            TransitionComponent={TransitionComponent}
            sx={{
              position: "absolute",
              marginX: "56px",
              width: "201px",
              marginBottom: "10px",
              textAlign: "center",
              pointerEvents: "none",
            }}
          />
        </>
      )}
    </Styled.PageContainer>
  );
};

export default IFrameWidget;
